import { Typography } from '@mui/material';

function OnAccountPayment() {
  return <Typography variant='adfBody1'>You will be sent an invoice</Typography>;
}

export default OnAccountPayment;
